import { Button, Flex, Heading, Text, TextField } from '@radix-ui/themes';
import { login } from '@/entities/session';
import {
  useAppDispatch,
  useAppSelector,
  useRedirectPath,
} from '@/shared/hooks';

export function LoginForm() {
  const dispatch = useAppDispatch();
  const isPending = useAppSelector((state) => state.auth.loading === 'pending');
  const { navigateToApp } = useRedirectPath();

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData(e.target as HTMLFormElement);
    const username = formData.get('username')?.toString() ?? '';
    const password = formData.get('password')?.toString() ?? '';

    if (login && password) {
      dispatch(login({ username, password }))
        .unwrap()
        .then(() => {
          navigateToApp();
        });
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <Heading mb="4">Sign In</Heading>
      <Text weight="medium" className="mb-2" size="1" asChild>
        <label htmlFor="username">Username</label>
      </Text>
      <TextField.Root
        className="mb-3"
        id="username"
        name="username"
        placeholder="Enter username"
      ></TextField.Root>
      <Text weight="medium" className="mb-2" size="1" asChild>
        <label htmlFor="password">Password</label>
      </Text>
      <TextField.Root
        className="mb-3"
        id="password"
        name="password"
        type="password"
        placeholder="Enter password"
      ></TextField.Root>

      <Flex justify="end">
        <Button disabled={isPending} type="submit">
          Sign in
        </Button>
      </Flex>
    </form>
  );
}
